// extracted by mini-css-extract-plugin
export var container = "styles-module--container--3wH32";
export var prompt = "styles-module--prompt--wmFJP";
export var title = "styles-module--title--K9zj2";